<div class="pl-tooltip" [ngClass]="theme">
  <div class="tooltip-container">
    <ng-content></ng-content>
  </div>
</div>
